import Link from "next/link";

import { useIsEmbed } from "@calcom/embed-core/embed-iframe";
import { POWERED_BY_URL } from "@calcom/lib/constants";
import { useLocale } from "@calcom/lib/hooks/useLocale";

const PoweredByCal = ({
  logoOnly,
}: {
  logoOnly?: boolean;
  hasValidLicense?: boolean | null;
}) => {
  const { t } = useLocale();
  const isEmbed = useIsEmbed();

  return (
    <div className={`p-2 text-center text-xs${isEmbed ? " max-w-3xl" : ""}`}>
      <Link href={POWERED_BY_URL} target="_blank" className="text-subtle mx-auto flex w-fit items-center justify-center gap-1">
        {!logoOnly && <span>{t("powered_by")}</span>}
        <img
          className="-mt-px inline h-[36px] w-auto dark:hidden"
          src="/schedly-logo-light.svg"
          alt="Schedly Logo"
        />
        <img
          className="-mt-px hidden h-[36px] w-auto dark:inline"
          src="/schedly-logo-dark.svg"
          alt="Schedly Logo"
        />
      </Link>
    </div>
  );
};

export default PoweredByCal;
